import { render, staticRenderFns } from "./tabBookingMasterUICustom.vue?vue&type=template&id=93681b76&scoped=true&"
import script from "./tabBookingMasterUICustom.vue?vue&type=script&lang=js&"
export * from "./tabBookingMasterUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabBookingMasterUICustom.vue?vue&type=style&index=0&id=93681b76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93681b76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93681b76')) {
      api.createRecord('93681b76', component.options)
    } else {
      api.reload('93681b76', component.options)
    }
    module.hot.accept("./tabBookingMasterUICustom.vue?vue&type=template&id=93681b76&scoped=true&", function () {
      api.rerender('93681b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/components/booking/tabs/tabBookingMasterUICustom.vue"
export default component.exports